import { useProductCatalogContext } from "../ProductCatalogContext";
import useCompanyCountQuery from "./hooks/useCompanyCountQuery";
import { Skeleton } from "../../../components/loading";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { abbreviateNumber } from "../../../utils/numberUtils";

export const CompanyCountCard = (props: { vendorId: number }) => {
  const { entityTypeFilterValue, localizeInstalls } =
    useProductCatalogContext();

  const { count, loading } = useCompanyCountQuery(
    props.vendorId,
    localizeInstalls,
    entityTypeFilterValue
  );

  return (
    <Box width="100%">
      <OutlinedPaper>
        <Stack id="company-count" gap={1} alignItems="center" p={2}>
          <Typography variant="h4">Number of Companies</Typography>
          <Skeleton isLoading={loading} width={40} height={20}>
            <Typography variant="h2">{abbreviateNumber(count)}</Typography>
          </Skeleton>
        </Stack>
      </OutlinedPaper>
    </Box>
  );
};
